import React from "react";

import { Cards, Chart, CountryPicker } from './components';
import { fetchData } from './api';
import styles from './App.module.css'
import image from './images/image.png';
import Button from '@material-ui/core/Button';
import { style } from "@material-ui/system";
import PhoneIcon from "@material-ui/icons/Phone";
import world from "./images/world.png";

class App extends React.Component {
  state = {
    data: {},
    country: '',
  }

  async componentDidMount() {
    const data = await fetchData();
    this.setState({ data });
  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);
    this.setState({ data, country: country });
  }
  render() {
    const { data, country } = this.state;
    return (
      <div className={styles.container}>
      	<div className={style.letra} >
           <h1>COVID-19 datos en tiempo real </h1>
        </div>
	<div className={styles.minicontainer}>
          <table>
             <tr>
               <td><div class="gfm-embed" data-url="https://www.gofundme.com/f/san-juan-diego-life-counseling-center/widget/medium"></div> </td>
               <td> <a href="https://github.com/JulioMelchorPinto/" ><img className={styles.image} src={image} alt="COVID-19" /> </a> </td>
             </tr>
          </table>      
	</div>
        <div className={style.letra}>
      		<h2>En M&eacute;xico, si presentas alg&uacute;n s&iacute;ntoma</h2>
        </div>
        <div> <Button variant="outlined"
                    href="tel:8000044800"
                    startIcon={<PhoneIcon />}
                    color="secondary"
                    size="large" >Llama</Button>
        </div>
       
      	<div className={styles.minicontainer}>
          <table>
             <tr>
               <td>Selecciona un pa&iacute;s: </td>
               <td> <a href="https://gisanddata.maps.arcgis.com/apps/opsdashboard/index.html#/bda7594740fd40299423467b48e9ecf6" >
                    <img className={style.image} src={world} alt="Mapa" />
                    </a>
               </td>
             </tr>
             <tr>
               <td><CountryPicker handleCountryChange={this.handleCountryChange} />
               </td>
             </tr>
          </table>
        </div>
      	<Cards data={data} />
      	<Chart data={data} country={country} />
      </div>
    );
  }
}
export default App;
